enum ReferenceType {
    NONE = "",
    REPLY = "rp",
    FORWARD = "fd"
}

export default ReferenceType;